import {
    IconButton,
    Box,
    Button,
    Stack,
    useMediaQuery,
    useTheme
} from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import { useDialog } from 'hooks';
import { getCurrentDay, originalDays } from 'utilities';

export function WeekButtonGroup({ selectedDay, onDayChange }) {
    const shortDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const today = getCurrentDay();
    const useShortLabels = useMediaQuery('(max-width:720px)');
    const useDaySelectModal = useMediaQuery('(max-width:500px)');
    const { select } = useDialog();

    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const handleDaySelect = async () => {
        const dayOptions = originalDays.map(day => ({
            label: day,
            value: day
        }));

        const result = await select({
            title: "Select Day",
            options: dayOptions,
            selectedValue: selectedDay
        });

        if (result) {
            onDayChange(result.value);
        }
    };

    if (useDaySelectModal) {
        return (
            <Box sx={{ width: '100%', pt: 2, pb: 2 }}>
                <Button
                    fullWidth
                    onClick={handleDaySelect}
                    variant="contained"
                >
                    {selectedDay}
                </Button>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Stack
                direction='row'
                alignItems='center'
                sx={{
                    pt: 2,
                    pb: 2,
                    overflowX: 'auto',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(7, 1fr)',
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '12px',
                        overflow: 'hidden',
                    }}
                >
                    {originalDays.map((day, index) => {
                        const isSelected = selectedDay === day;
                        const displayDay = useShortLabels ? shortDays[index] : day;

                        return (
                            <Button
                                key={index}
                                variant={isSelected ? "contained" : "outlined"}
                                onClick={() => onDayChange(day)}
                                sx={{
                                    flex: 1,
                                    borderRadius: 0,
                        
                                    textTransform: 'none',
                                    fontWeight: 500,

                                    ...(isSelected && {
                                        backgroundColor: theme.palette.primary.main,
                                        color: theme.palette.primary.contrastText,
                                        '&:hover': {
                                            backgroundColor: isDark ? '#f1f5f9' : '#242424ff',
                                        },
                                    }),

                                    ...(!isSelected && {
                                        color: theme.palette.primary.main,
                                        borderColor: isDark ? '#333333' : '#d1d5db',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            borderColor: theme.palette.primary.main,
                                            backgroundColor: isDark ? '#1a1a1a' : 'rgba(0, 0, 0, 0.04)',
                                        },
                                    }),

                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                {displayDay}
                            </Button>
                        );
                    })}
                </Box>

                {selectedDay !== today && (
                    <IconButton
                        onClick={() => onDayChange(today)}
                        sx={{
                            marginLeft: 1,
                            color: 'black',
                            border: '2px solid black',
                            borderRadius: '10px',
                            fontWeight: 500,
                            '&:hover': {
                                backgroundColor: '#eee',
                                borderColor: 'black',
                            },
                        }}
                    >
                        <RestoreIcon fontSize='small' />
                    </IconButton>
                )}
            </Stack>
        </Box>
    );
}